export default __webpack_public_path__ + "locales/de/Common.json?hash=bf93a9a57a970562b7f6f904e1258ea6";